import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { DiscountService } from 'src/app/services/discount.service';
import type { IBookPreview } from '@shared/jp/data/products';

@Component({
  selector: 'app-book[book]',
  templateUrl: './book.component.html',
  styleUrls: ['./book.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookComponent {
  @Input() book!: IBookPreview | Readonly<IBookPreview>;

  @Output() buttonClick = new EventEmitter<void>();

  constructor(public discountService: DiscountService) {}

  public onButtonClick() {
    this.buttonClick.emit();
  }
}
